import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronDown, MapPin } from "lucide-react";
import { useLocationCtx } from "@/context/LocationContext";
import LocationSheet from "@/components/LocationSheet";

export default function Header({ subtitle }) {
  const navigate = useNavigate();
  const { loc } = useLocationCtx();
  const [sheetOpen, setSheetOpen] = useState(false);

  const locLabel = loc.city || loc.state || "Todas las ubicaciones";

  return (
    <header className="sticky top-0 z-40 glass border-b border-black/5 px-5 pb-3 pt-5">
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-0.5">
          <img src="/logo-saipass.png" alt="SAIPASS Beneficios" className="h-9 w-auto self-start" data-testid="brand-logo" />
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#5C5C5C]">
            Directorio de Negocios Locales
          </span>
        </div>
        <button
          onClick={() => setSheetOpen(true)}
          data-testid="location-pill"
          className="flex max-w-[45%] items-center gap-1 rounded-full bg-[#F3F0E6] px-3 py-2"
        >
          <MapPin size={14} className="shrink-0 text-[#E54D2E]" strokeWidth={2.5} />
          <span className="truncate text-xs font-bold text-[#1A1A1A]">{locLabel}</span>
          <ChevronDown size={14} className="shrink-0 text-[#5C5C5C]" />
        </button>
      </div>

      <button
        onClick={() => navigate("/buscar")}
        data-testid="search-bar-trigger"
        className="mt-3 flex w-full items-center gap-2 rounded-2xl border border-black/5 bg-white px-4 py-3 text-left"
      >
        <Search size={18} className="text-[#5C5C5C]" />
        <span className="text-sm text-[#9c9c9c]">Buscar negocios, categorías...</span>
      </button>

      <LocationSheet open={sheetOpen} onClose={() => setSheetOpen(false)} />
    </header>
  );
}
